/**
 * Common Logging Hook
 * Logs all messages regardless of direction
 * Used by both incoming and outgoing pipelines
 */
import { LogHook as BaseLogHook } from 'edge-stream-js';
import { type HookMetadata } from '../HookMetadata';

export class LogHook extends BaseLogHook {
  metadata?: HookMetadata = {
    name: 'LogHook',
    description: 'Logs all messages to console and logging service regardless of direction',
    version: '1.0.0',
    author: 'EdgeStream',
    tags: ['logging', 'common', 'monitoring'],
    modifiesData: false,
    impactLevel: 'medium',
  };

  constructor() {
    super();
  }
}
